export const PILOT_GPRS_CONSO_CARD_FRENCH_LOCALE = {
  title: "Conso. GPRS",
  updated: "Mis à jour { relativeDate }",
  alert: "Alerte",
  alertDate: "Emise le { date }",
};
